import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import User from '@capturum/auth/lib/user.interface';
import { AuthConfig, AuthService, AuthStorage } from '@capturum/auth';
import { LoginService } from '../login.service';
import { LoginAction } from '../base/login-action.enum';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

interface AuthResult<T> {
  status: string;
  token: string;
  user: T;
  refresh_token?: string;
  sso?: boolean;
}

@Injectable()
export class SsoCallbackResolver<USER extends User = never> implements Resolve<AuthResult<USER&{ roles }>> {
  constructor(private http: HttpClient,
              private authService: AuthService,
              protected config: AuthConfig,
              protected loginService: LoginService) {
  }

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AuthResult<USER&{ roles }>> {
    const activeUrl = state.url;
    const azureCredentials = activeUrl.substring(activeUrl.indexOf('?'));
    const url = `${this.config.baseUrl}/sso-callback${azureCredentials}`;

    return this.http.get(url).pipe(
      tap((result: AuthResult<USER&{ roles }>) => {
        if (result.status === 'ok') {
          result.sso = true;

          if (result.user) {
            if (result.user.roles !== undefined && result.user.roles.data !== undefined) {
              result.user.roles = result.user.roles.data;
            }

            const user = result.user;

            AuthStorage.setItem('user', JSON.stringify(user));
          }

          AuthStorage.setItem('token', result.token);

          if (result.refresh_token) {
            AuthStorage.setItem('refresh_token', result.refresh_token);
          }

          this.authService.handleSuccessfulLogin(result);
          this.authService.setAuthenticationState(true);

          this.loginService.setAction(LoginAction.login, true);
          this.loginService.onLoginSuccess(result);
        }
      }),
    );
  }
}
